import { applyNonceToElement } from 'core/utils/csp-nonce';
import { environment } from 'environment';

export function appendDCRCookieConsentScript(lang: string, code: string) {
  const englishLang = 'en-gb';
  const environmentPrefix = environment.production ? '' : 'staging.';
  const policyCode = code && lang === englishLang ? code : 'b6231a84';
  const url = `//${environmentPrefix}policy.cookiereports.com/${policyCode}_panel-${lang}.js`;
  const alreadyExits = document.querySelector('script[src="' + url + '"]');

  if (lang !== englishLang) {
    const scriptTag = document.getElementById('dcr');
    const scriptSrc = scriptTag ? scriptTag.getAttribute('src') : '';
    const isEnGBScriptExits = scriptSrc.includes(englishLang);
    if (isEnGBScriptExits) document.head.removeChild(scriptTag);
  }
  if (!alreadyExits) {
    const script = document.createElement('script');
    script.id = 'dcr';
    script.src = url;
    script.type = 'text/javascript';
    applyNonceToElement(script);
    document.head.insertBefore(script, document.head.lastChild);
  }
}
